import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuthAdmin } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const adminLogin = createAsyncThunk(
  'adminAuth/login',
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuthAdmin(apiUrls.adminLogin, {}, 'POST', loginData);

      if (response?.data?.success && response?.data?.status === 200) {
        const data = response.data.data;
        const userData = {
          id: data.admin?.id,
          email: data.admin?.email,
          firstName: data.admin?.firstName,
          isSuperAdmin: data.admin.isSuperAdmin,
          lastName: data.admin?.lastName,
          role: data.admin?.role,
          lastLogin: data.admin?.lastLogin,
          token: data.token
        };
        localStorage.setItem('adminToken', data.token);
        localStorage.setItem('adminData', JSON.stringify(userData));

        localStorage.setItem('modules', JSON.stringify([]));
        localStorage.setItem('adminType', 'admin');

        window.dispatchEvent(new Event('login'));

        return {
          user: userData,
          modules: []
        };
      } else {
        return rejectWithValue(response?.data?.message || "Admin login failed");
      }
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err?.message || "An error occurred during login");
    }
  }
);

export const adminLogout = createAsyncThunk('adminAuth/logout', async () => {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminData");
  localStorage.removeItem("modules");
  localStorage.removeItem("adminType");
  window.dispatchEvent(new Event('logout'));
  return null;
});

export const checkAdminAuth = createAsyncThunk('adminAuth/checkAuth', async () => {
  const token = localStorage.getItem('adminToken');
  const adminData = localStorage.getItem('adminData');
  const modules = localStorage.getItem('modules');

  if (token && adminData) {
    const parsedAdminData = JSON.parse(adminData);
    return {
      isAuthenticated: true,
      user: parsedAdminData,
      modules: modules ? JSON.parse(modules) : []
    };
  }
  return { isAuthenticated: false, user: null, modules: [] };
});

const initialState = {
  user: null,
  modules: [],
  isAuthenticated: false,
  loading: false,
  error: null,
};

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    clearAdminError: (state) => {
      state.error = null;
    },
    updateAdminUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem('adminData', JSON.stringify(state.user));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.modules = action.payload.modules || [];
        state.error = null;
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
        state.user = null;
      })
      .addCase(adminLogout.fulfilled, (state) => {
        state.user = null;
        state.modules = [];
        state.isAuthenticated = false;
        state.loading = false;
        state.error = null;
      })
      .addCase(checkAdminAuth.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.isAuthenticated;
        state.user = action.payload.user;
        state.modules = action.payload.modules;
      });
  },
});

export const { clearAdminError, updateAdminUser } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;